import { Icon } from '@iconify/react/dist/iconify.js';
import { Button, Tooltip } from '@/components/ui';
import type { ActionKey } from './columns';
import type { User } from '@/shared/types/user';

export function UserActions({
  item,
  onAction,
}: {
  item: User;
  onAction: (item: User, action: ActionKey) => void;
}) {
  const canArchive = !item.data.archived;

  return (
    <div className='flex flex-row items-center justify-center gap-1'>
      <Tooltip content='Edit'>
        <Button
          isIconOnly
          variant='light'
          size='sm'
          onPress={() => onAction(item, 'edit')}
          aria-label='Edit user'
        >
          <Icon icon='mdi:pencil-outline' width={20} height={20} />
        </Button>
      </Tooltip>
      {canArchive && (
        <Tooltip content='Archive'>
          <Button
            isIconOnly
            variant='light'
            size='sm'
            onPress={() => onAction(item, 'archive')}
            aria-label='Archive user'
          >
            <Icon icon='mdi:archive-outline' width={20} height={20} />
          </Button>
        </Tooltip>
      )}
    </div>
  );
}
